import * as React from 'react'
import {Suspense, useEffect} from 'react'
import AliceCarousel from 'react-alice-carousel'
import {Helmet} from 'react-helmet'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import DataDriven from '../components/dataDriven'
import SimpleList from '../components/simpleList'
import Steps from '../components/steps'
import '../css/rtb.css'
import AppProps from '../util/appProps'
import {goToElementId, goToHash, tagger, setTitleFont} from '../util/util'
import CaseStudies from '../components/caseStudies'
import LazyLoad from 'react-lazyload'

const ReactImageMagnify = React.lazy(() => import('react-image-magnify'))
const Experiences = React.lazy(() => import('../lotties/experiences/experiences'))
const ReEngagement = React.lazy(() => import('../lotties/re_engagement/reEngagement'))
const Fraud = React.lazy(() => import('../lotties/fraud/fraud'))
const UserAppAnimation = React.lazy(() => import('../lotties/user_app/userApp'))

const RTB = (props: AppProps) => {

    const tC = useTranslation('common').t
    const {t, i18n} = useTranslation('rtb')
    const tL = useTranslation('landing').t

    const aquaText = 'aqua-text'
    const handleOnDragStart = (e) => e.preventDefault()

    const scrollToHandler = () => {goToElementId('rtb-container', true)}

    // let [state, setState] = useState({
    //     currentControlPage: 0
    // })

    useEffect(() => {
        setTitleFont(i18n.language)
    }, [])

    useEffect(() => goToHash(props), [props.location.hash])

    const controlImgList = [
        {small: 'https://static.persona.ly/images/rtb/rtb-1-small.webp', large: 'https://static.persona.ly/images/rtb/rtb-1.webp'},
        {small: 'https://static.persona.ly/images/rtb/rtb-2-small.webp', large: 'https://static.persona.ly/images/rtb/rtb-2.webp'},
        {small: 'https://static.persona.ly/images/rtb/rtb-3-small.webp', large: 'https://static.persona.ly/images/rtb/rtb-3.webp'}
    ]

    return (
        <div className="rtb">
            <div className="down-scroll not-tablet not-mobile" onClick={scrollToHandler}>
                <p className="down-scroll-text">SCROLL</p>
                <span className="down-scroll-animation down-scroll-animation-green"> </span>
            </div>
            <div className="main-content">
                <Helmet>
                    <title>Machine learning driven mobile user acquisition & re-targeting</title>
                    <meta name="title" content="Machine learning driven mobile user acquisition & re-targeting" />
                    <meta name="description" content="Persona.ly offers a programmatic & fully transparent service, from playable and dynamic creative generation, to driving scale and providing actionable marketing insights" />
                    <meta name="keywords" content="User Acquisition, Programmatic User Acquisition, Mobile UA, Retargeting, Re-engagement, Playable Ads, Interactive Ads, Dynamic Ads, Performance-based Campaigns" />
                </Helmet>
                <div>
                    <div className="title muli not-desktop not-mobile">{tagger(tL('Parsing Data I'), aquaText)}</div>
                    <div className="rtb-c-b">
                        <div className="tablet rtb-parsing-data">
                            <div className="title muli not-tablet">{tagger(tL('Parsing Data I'), aquaText)}</div>
                            <div className="block-p">{tL('Machine learning d')}</div>
                            <div className="block-c">{tagger(tL('Personaly offers'), 'aqua-text fw700')}</div>
                            <Link to="contact"><button className="button-aqua large">{tC('Start Now')}<img src="https://static.persona.ly/images/arrow.svg" /></button></Link>
                            <div className="block-c trusted-rtb not-tablet not-mobile">{tL('Trusted by')}</div>
                            <img className="not-tablet not-mobile" src="https://static.persona.ly/images/clients.svg" />
                        </div>
                        <div className="lottie-user-app-container tablet">
                            <Suspense fallback="">
                                <UserAppAnimation />
                            </Suspense>
                        </div>
                    </div>
                    <div className="block-c trusted-rtb not-desktop supported">{tL('Trusted by')}</div>
                    <img className="not-desktop trusted-rtb-img" src="https://static.persona.ly/images/clients.svg" />
                </div>
            </div>
            <div id="rtb-container" className="rtb-content">
                <div>
                    <div className="headquarters-t muli">{tagger(t('Identifying Your U'), aquaText)}</div>
                    <div className="block-c rtb-description">{t('Our algorithms a')}</div>
                    <Steps blocks={
                        [
                            {
                                title: t('Impression Level F'), textList: [
                                    t('placement in app'),
                                    t('day n time'),
                                    t('creative type'),
                                    t('rtb exchange'),
                                    t('historical p')
                                ], img: 'https://static.persona.ly/images/rtb/impression-level-features-ilu.svg'
                            },
                            {
                                title: t('User-Centric Features'), textList: [
                                    t('category retention'),
                                    t('geo location'),
                                    t('installed apps'),
                                    t('usage hours'),
                                    t('perceived persona'),
                                    t('session depth')
                                ], img: 'https://static.persona.ly/images/rtb/user-centric-features-ilu.svg'
                            },
                            {
                                title: t('Engagement Analysis'), textList: [
                                    t('click tendency'),
                                    t('in-ad behavoir'),
                                    t('click depth'),
                                    t('viewability')
                                ], img: 'https://static.persona.ly/images/rtb/engagement-analysis-ilu.svg'
                            },
                        ]
                    } />
                </div>
                <div>
                    <div className="headquarters-t muli">{tagger(t('Our Data-Driven Process'), aquaText)}</div>
                    <div className="block-c rtb-description">{t('While similarities b')}</div>
                    <DataDriven className="ddp-rtb aqua-text" full />
                </div>
                <LazyLoad>
                    <div id="ad-creatives">
                        <div className="headquarters-t muli">{tagger(t('Immersive and P'), aquaText)}</div>
                        <div className="block-c rtb-description">{t('The mobile apps industry')}</div>
                        <div className="block-c rtb-description">{t('To have the r')}</div>
                        <div className="rtb-animation-container">
                            <div className="rtb-ads-1">
                                <div className="content-block">
                                    <div className="block-preview">
                                        <img alt="" src="https://static.persona.ly/images/monetization/dynamic-ads-ilu.svg" />
                                        <iframe src="https://static.persona.ly/images/monetization/cookie_jam.html" frameBorder={0} />
                                    </div>
                                </div>
                                <div>
                                    <div><span className="aqua-text">{tagger(t('Playable & Intera'), '') }</span></div>
                                    <div>{t('Interactive ads offer t')}</div>
                                    <div>{t('Playable ads are')}</div>
                                    {/* <div>See More</div> */}
                                </div>
                            </div>
                            <div className="rtb-ads-2">
                                <div className="lottie-experiences-container">
                                    <Suspense fallback="">
                                        <Experiences />
                                    </Suspense>
                                </div>
                                <div>
                                    <div><span className="aqua-text">{t('Dynamic Ads')}</span></div>
                                    <div>{t('Dynamic ads are c')}</div>
                                    <div>{t('Dynamic ads are all')}</div>
                                    {/* <div>See More</div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </LazyLoad>
                <LazyLoad>
                    <div id="retargeting">
                        <div className="headquarters-t muli">{tagger(t('Turn Inactive U'), aquaText)}</div>
                        <div className="block-c rtb-description">{t('Reaching out to d')}</div>
                        <div className="rtb-re-engaged">
                            <div className="lottie-re-engaged-container">
                                <Suspense fallback="">
                                    <ReEngagement />
                                </Suspense>
                            </div>
                            <div>
                                <div>
                                    <p className="fw700"><span className="aqua-text">{t('detecting inactive users')}</span></p>
                                    <p>{t('in the bidstream')}</p>
                                </div>
                                <div>
                                    <p className="fw700">{tagger(t('Creating an incentivized ad'), aquaText)}</p>
                                    <p>{t('based on aggreggated b')}</p>
                                </div>
                                <div>
                                    <p className="fw700">{tagger(t('Displaying the ad'), aquaText)}</p>
                                    <p>{t('the dormant')}</p>
                                </div>
                                <div>
                                    {t('Rewarding the user')}
                                </div>
                            </div>
                        </div>
                    </div>
                </LazyLoad>
                <LazyLoad>
                    <div>
                        <div className="headquarters-t muli">{tagger(t('Affirmed Quality Users'), aquaText)}</div>
                        <div className="block-c rtb-description">{t('Our customized machine')}</div>
                        <div className="rtb-fraud">
                            <SimpleList blocks={[
                                {
                                    title: t('Inventory'),
                                    textList: [t('Our proprietary')],
                                    img: 'https://static.persona.ly/images/rtb/inventory.svg'
                                }, {
                                    title: t('Fraud Prevention'),
                                    textList: [t('Using a scheme of rules')],
                                    img: 'https://static.persona.ly/images/rtb/fraud-prevention.svg'
                                }, {
                                    title: t('Exclusively In-App'),
                                    textList: [t('All of our impressions')],
                                    img: 'https://static.persona.ly/images/rtb/group-15.svg'
                                }, {
                                    title: t('members of caaf'),
                                    textList: [t('proud members of'), tagger(t('read more'), 'a-white fw700', 'https://www.adjust.com/blog/spotlight-on-caaf-three-new-members/', true) as any],
                                    img: 'https://static.persona.ly/images/rtb/group-25.svg'
                                }
                            ]} />
                            <div className="lottie-fraud-container">
                                <Suspense fallback="">
                                    <Fraud />
                                </Suspense>
                            </div>
                        </div>
                    </div>
                </LazyLoad>
                <LazyLoad>
                    <div id="transparency">
                        <div className="headquarters-t muli">{tagger(t('Transparent & Actionable'), aquaText)}</div>
                        <div className="block-c rtb-description">{t('Analyzing decisions made by')}</div>
                        <div className="block-c rtb-description">{t('Our dashboard provides')}</div>
                        <div className="rtb-performance">
                            <div className="images-rounded">
                                <AliceCarousel
                                    mouseTrackingEnabled
                                    buttonsDisabled
                                    infinite={false}
                                    items={controlImgList.map((img, i) => (
                                        <Suspense key={i} fallback="">
                                            <ReactImageMagnify onDragStart={handleOnDragStart} {...{
                                                smallImage: {
                                                    isFluidWidth: true,
                                                    src: img.small
                                                },
                                                largeImage: {
                                                    src: img.large,
                                                    width: 1440,
                                                    height: 900
                                                },
                                                style: {cursor: 'zoom-in'},
                                                enlargedImagePosition: 'over',
                                                isHintEnabled: true,
                                                hintTextMouse: 'Hover to Zoom',
                                                hintTextTouch: 'Long-Touch to Zoom'
                                            }} />
                                        </Suspense>
                                    ))}
                                />
                            </div>
                            <SimpleList blocks={[
                                {
                                    title: t('Creative Analysis'),
                                    textList: [t('Easily view and analyze')],
                                    img: 'https://static.persona.ly/images/rtb/creative-analysis.svg'
                                }, {
                                    title: t('Performance Reports'),
                                    textList: [t('Get a full overview o')],
                                    img: 'https://static.persona.ly/images/rtb/group-22-2.svg'
                                }, {
                                    title: t('Demographic Insights'),
                                    textList: [t('Gain insights regarding')],
                                    img: 'https://static.persona.ly/images/rtb/demographic-insights.svg'
                                }
                            ]} />
                        </div>
                    </div>
                </LazyLoad>
                <div className="case-studies-wrapper">
                    <CaseStudies/>
                </div>
            </div>
        </div>
    )
}

export default RTB


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/rtb.tsx